import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';
import {DashboardComponent} from './dashboard.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.dashboard.pageInRouting,
    data: {data: PAGES_AND_PATHS.dashboard},
    component: DashboardComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./dashboard.module').then(m => m.DashboardModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
